import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { Lock } from 'lucide-react'

export interface PlanLockBadgeProps {
	className?: string
	label?: string
}

export function PlanLockBadge({ className, label }: PlanLockBadgeProps) {
	return (
		<Badge variant='outline' className={cn('gap-1 text-muted-foreground', className)}>
			<Lock className='size-3' />
			{label ?? 'Locked'}
		</Badge>
	)
}
